import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter} from "react-router-dom";
import * as serviceWorker from './serviceWorker';
import {Provider} from 'react-redux'
import {configureStore} from './redux/store'
import App from './App';
const Routers = () => {
  return (
    <Provider store={configureStore()}>
   <BrowserRouter basename="/en">
    <App />
  </BrowserRouter>
    </Provider>
)
}

 
ReactDOM.render(<Routers />, document.getElementById('root'));
serviceWorker.register();
